import React, { useState, useEffect } from 'react';
import Header from './Header';
import Footer from './Footer';
import ProcessDevice from './ProcessDevice';
import OurProductsSection from "./OurProductsSection"

import '../styles/AutomobilesAndParts.css';

import AutomotiveIndustryImg from '../assets/AutomotiveIndustryImg.jpg'

const AutomobilesAndParts = () => {
  const [showModal, setShowModal] = useState(false);


  return (
    <div className="AutomobilesAndParts">
      <Header />

      {/* Hero Banner Section */}
      {/* <section className="hero-banner7">
        <div className="hero-content">
          <h1>AUTOMOBILES AND PARTS</h1>
          <div className="breadcrumb">
            <span><a href="/" style={{ color: "#ACECFC" }}>Home</a></span> ⪢ <span>Automobiles And Parts</span>
          </div>
        </div>
      </section> */}

<section className="automotive-hero-clean">
  <div className="hero-text">
    <h1>Automotive Industry</h1>
    <p>
From initial stamping to welding, painting, forging and casting to final assembly，we know every area down to the finest details and offer just the right sensors.    </p>
  </div>
  <br/>
  <div className="hero-image">
    <img src={AutomotiveIndustryImg} alt="automotive Industry" />
  </div>
</section>


<ProcessDevice />
<OurProductsSection />

      <Footer />
    </div>
  );
};
export default AutomobilesAndParts;